import {
  GET_APPLICATIONS,
  GET_APPLICATION,
  GET_APPLICATION_USERS,
  GET_APP_SALT,
  CREATE_APPLICATION,
  EDIT_APPLICATION,
  ADD_NEW_USER_TO_APPLICATION,
  DELETE_USER_APPLICATION,
  requestType,
  failedType,
  succeedType,
} from "./../actions/actionTypes";

const initState = {
  application: {},
  applications: [],
  application_users: [],
  selected_app_salt: null,
  is_fetching: false,
  getting_application_salt: false,
  getting_application: false,
  getting_application_users: false,
  creating_application: false,
  editing_application: false,
  adding_user_to_application: false,
};

export const applicationReducer = (state = initState, action) => {
  switch (action.type) {
    case requestType(DELETE_USER_APPLICATION):
    case requestType(GET_APPLICATIONS):
      return {
        ...state,
        is_fetching: true,
      };
    case requestType(DELETE_USER_APPLICATION):
    case succeedType(DELETE_USER_APPLICATION):
    case failedType(GET_APPLICATIONS):
      return {
        ...state,
        is_fetching: false,
      };
    case succeedType(GET_APPLICATIONS):
      return {
        ...state,
        is_fetching: false,
        applications: action.applications,
      };
    case requestType(GET_APPLICATION):
      return {
        ...state,
        getting_application: true,
      };
    case failedType(GET_APPLICATION):
      return {
        ...state,
        getting_application: false,
      };
    case succeedType(GET_APPLICATION):
      return {
        ...state,
        getting_application: false,
        application: action.application,
      };
    case requestType(GET_APPLICATION_USERS):
      return {
        ...state,
        getting_application_users: true,
      };
    case failedType(GET_APPLICATION_USERS):
      return {
        ...state,
        getting_application_users: false,
      };
    case succeedType(GET_APPLICATION_USERS):
      return {
        ...state,
        getting_application_users: false,
        application_users: action.application_users,
      };
    case requestType(CREATE_APPLICATION):
      return {
        ...state,
        creating_application: true,
      };
    case failedType(CREATE_APPLICATION):
      return {
        ...state,
        creating_application: false,
      };
    case succeedType(CREATE_APPLICATION):
      return {
        ...state,
        creating_application: false,
      };
    case requestType(EDIT_APPLICATION):
      return {
        ...state,
        editing_application: true,
      };
    case failedType(EDIT_APPLICATION):
      return {
        ...state,
        editing_application: false,
      };
    case succeedType(EDIT_APPLICATION):
      return {
        ...state,
        editing_application: false,
      };
    case requestType(ADD_NEW_USER_TO_APPLICATION):
      return {
        ...state,
        adding_user_to_application: true,
      };
    case failedType(ADD_NEW_USER_TO_APPLICATION):
      return {
        ...state,
        adding_user_to_application: false,
      };
    case succeedType(ADD_NEW_USER_TO_APPLICATION):
      return {
        ...state,
        adding_user_to_application: false,
      };
    case requestType(GET_APP_SALT):
      return {
        ...state,
        getting_application_salt: true,
      };
    case failedType(GET_APP_SALT):
      return {
        ...state,
        getting_application_salt: false,
      };
    case succeedType(GET_APP_SALT):
      return {
        ...state,
        getting_application_salt: false,
        selected_app_salt: action.selected_app_salt,
      };
    default:
      return state;
  }
};
